import { InjectionToken } from '@angular/core';
import { IRouteItem } from '@shared/interfaces';

export const SETTINGS_ROUTE_ITEMS: InjectionToken<IRouteItem[]> = new InjectionToken('SETTINGS_ROUTE_ITEMS');
